import React, { useState } from 'react';
import {Button, Modal, Upload} from 'antd';
import {UploadFile} from "antd/es/upload/interface";
import {UploadChangeParam} from "antd/lib/upload";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {notifications} from "../../../../services/notifications/notifications";

export interface FileUploaderProps<T> {
    upload: (file: File) => Promise<T>;
    value?: CustomUploadFile[];
    onChange?: (value: CustomUploadFile[]) => void;
    onRemove?: (value: CustomUploadFile) => Promise<any>;
}

export interface CustomUploadFile extends UploadFile {
}

export interface Response {
    id: number;
    filename: string;
    url: string;
}

function isImage(url: string): boolean {
    return /\.(jpg|jpeg|png|webp|avif|gif|svg)$/.test(url);
}

export const FileUploader = <T extends Response>({value, onChange, onRemove, upload}: FileUploaderProps<T>) => {

    const [previewFile, setPreviewFile] = useState<UploadFile<T>|null>(null);

    const onUploadChange = (event: UploadChangeParam<UploadFile<T>>) => {

        if (event.file.response) {
            const resp = event.file.response;
            const newFile: CustomUploadFile | undefined = event.fileList.find(file => file.uid === event.file.uid);
            if (newFile) {
                newFile.url = resp.url;
                newFile.fileName = resp.filename;
                newFile.uid = resp.id.toString();
            }
        }

        onChange && onChange(event.fileList);
    };

    const onPreview = (file: CustomUploadFile): any => {
        setPreviewFile(file);
    };

    const closePreview = (): any => {
        setPreviewFile(null);
    };

    const onRemoveWrapped = (value: CustomUploadFile): Promise<any> => {
        if (value.status === "removed" || value.status === "error" || !onRemove) {
            return Promise.resolve();
        }

        return onRemove(value);
    }

    return (
        <>
            <Upload
                customRequest={async (options: any) => {
                    try {
                        options.onProgress({percent: 10});
                        options.onSuccess(await upload(options.file as File));
                    } catch (e: any) {
                        if (!e?.response?.data?.messages) {
                            const message = e?.response?.data?.fields?.[0]?.errors?.[0] ?? 'Unknown error';
                            notifications.message('error', message)
                        }
                        options.onError();
                    }
                }}
                listType="picture-card"
                fileList={value}
                onChange={onUploadChange}
                onPreview={onPreview}
                onRemove={onRemoveWrapped}
                showUploadList={{
                    showDownloadIcon: true,
                    showPreviewIcon: true,
                    showRemoveIcon: true
                }}
            >
                <Button type={"text"} icon={<FontAwesomeIcon icon={["fas", "upload"]} />}>Upload</Button>
            </Upload>
            {!!previewFile ? (
                <Modal
                    maskClosable={false}
                    title={previewFile?.name || ''}
                    footer={null}
                    onCancel={closePreview}
                >
                    {isImage(previewFile.url || "") ? (
                        <img alt="example" style={{ width: '100%' }} src={previewFile?.url || ''} />
                    ) : (
                        <>Preview is not available</>
                    )}
                </Modal>
            ) : null}
        </>
    );
};